const COMPETITORS_STORAGE_PREFIX = 'soho_competitors_'

const INTERNAL_BENCHMARK_TYPES = new Set(['brand average', 'internal benchmark'])

export function isInternalBenchmarkCompetitor(competitor = {}) {
  const type = String(competitor.type || '').trim().toLowerCase()
  const subBrand = String(competitor.subBrand || '').trim().toLowerCase()
  return INTERNAL_BENCHMARK_TYPES.has(type) || INTERNAL_BENCHMARK_TYPES.has(subBrand)
}

export function resolveExecutiveClientId(clientId) {
  if (clientId) return String(clientId)
  try {
    const fromSession = sessionStorage.getItem('selectedClientId')
    return fromSession ? String(fromSession) : null
  } catch {
    return null
  }
}

export function loadConfiguredCompetitors(clientId) {
  const resolvedClientId = resolveExecutiveClientId(clientId)
  if (!resolvedClientId) return []

  try {
    const raw = localStorage.getItem(`${COMPETITORS_STORAGE_PREFIX}${resolvedClientId}`)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((entry) => entry && (entry.property || entry.brand || entry.type))
  } catch {
    return []
  }
}

export function aggregateCompetitorsToPeerGroups(competitors = []) {
  const groups = new Map()

  competitors.forEach((competitor) => {
    if (isInternalBenchmarkCompetitor(competitor)) return

    const groupName = String(competitor.brand || competitor.property || '').trim()
    if (!groupName) return

    const groupKey = groupName.toLowerCase()
    if (!groups.has(groupKey)) {
      groups.set(groupKey, {
        id: `peer-${groupKey.replace(/[^a-z0-9]+/g, '-')}`,
        name: groupName,
        brand: groupName,
        sourceCompetitorIds: [competitor.id].filter(Boolean),
      })
      return
    }

    const existing = groups.get(groupKey)
    if (competitor.id) {
      existing.sourceCompetitorIds.push(competitor.id)
    }
  })

  return Array.from(groups.values())
}

export function loadConfiguredPeerGroups(clientId) {
  const competitors = loadConfiguredCompetitors(clientId)
  const peerGroups = aggregateCompetitorsToPeerGroups(competitors)
  return {
    peerGroups,
    configuredPeerCount: peerGroups.length,
    hasConfiguredPeers: peerGroups.length > 0,
    storageKey: clientId ? `${COMPETITORS_STORAGE_PREFIX}${clientId}` : null,
  }
}

export function formatConfiguredPeerGroupsLabel(count) {
  const safeCount = Number.isFinite(count) ? Math.max(0, count) : 0
  return `${safeCount} configured peer group${safeCount === 1 ? '' : 's'}`
}
